import { TravelDocsErrors } from '../interface/travel-docs.interface';

export const TRAVEL_DOCS_ERRORS: TravelDocsErrors = {
  travelrequirement_030_001: {
    title: 'FirstNameAndLastNameMismatch',
    statusCode: 'travelrequirement_030_001',
    statusDescriptionDotcomUI:
      '<b>Name mismatch.</b> Please re-scan your passport and verify that your name appears exactly as it does on your ticket.',
    statusDescriptionFDA:
      'Name mismatch. Please re-scan your passport and verify that your name appears exactly as it does on your ticket.',
    priority: '2',
    color: 'Red',
    errorType: 'PassportError'
  },
  travelrequirement_030_003: {
    title: 'LastNameMismatch',
    statusCode: 'travelrequirement_030_003',
    statusDescriptionDotcomUI:
      '<b>Surname (last name) mismatch.</b> Please re-scan your passport and verify that your last name appears exactly as it does on your ticket.',
    statusDescriptionFDA:
      'Surname (last name) mismatch. Please re-scan your passport and verify that your last name appears exactly as it does on your ticket.',
    priority: '2',
    color: 'Red',
    errorType: 'PassportError'
  },
  travelrequirement_030_011: {
    title: 'ReturnOnwardTicketNeeded',
    statusCode: 'travelrequirement_030_011',
    statusDescriptionDotcomUI:
      '<b>Return ticket required for your destination.</b> Please show a physical or digital ticket to a Delta agent.',
    statusDescriptionFDA:
      'Return ticket required for your destination. Please show a physical or digital ticket to a Delta agent.',
    priority: '6',
    color: 'Red',
    errorType: 'PassportError'
  },
  travelrequirement_050_005: {
    title: 'InvalidReturnOnwardDate',
    statusCode: 'travelrequirement_050_005',
    statusDescriptionDotcomUI:
      '<b>Passport does not meet destination expiration requirements.</b> Please renew your passport before departure and/or update your information if already renewed.',
    statusDescriptionFDA:
      'Passport does not meet destination expiration requirements. Please renew your passport before departure and/or update your information if already renewed.',
    priority: '4',
    color: 'Red',
    errorType: 'PassportError'
  }
};
